import { USER_CURRENCY } from "utils/constants";

export const STATUS_LIST = ["New", "Active", "Expired", "Pending"];
export const REGISTRATION_CATEGORY_LIST = ["Residential", "Commercial"];
export const STATUS_COLOR_MAP = {
  Active: {
    color: "#17C347",
    backgroundColor: "#D8FFE3",
  },
  Expired: {
    color: "#FF0000",
    backgroundColor: "#FF00001A",
  },
  New: {
    color: "#DB6607",
    backgroundColor: "#DB660726",
  },
  Pending: {
    color: "#0085FF",
    backgroundColor: "#0085FF26",
  },
};

export const VALIDATION_RULES = [{ required: true, message: "Please enter value" }];

export const PRICE_TYPES_OPTION = {
  DEFAULT: "Default",
  DEPOT: "Depot",
  CONSUMPTION_BAND: "Consumption",
  CUSTOMER_GROUP: "CustomerGroup",
};
export const PRICE_TYPES = [
  PRICE_TYPES_OPTION.DEFAULT,
  PRICE_TYPES_OPTION.DEPOT,
  // PRICE_TYPES_OPTION.CONSUMPTION_BAND,
  PRICE_TYPES_OPTION.CUSTOMER_GROUP,
];

export const PRICING_OPTIONS = [
  {
    title: "Actual",
    value: "Actual",
    subTitle: "Set a fixed amount as price",
  },
  {
    title: "Discount (%)",
    value: "DiscountPercentage",
    subTitle: "Set a % discount from the default price",
  },
  {
    title: "Discount (Amount)",
    value: "DiscountAmount",
    subTitle: "Amount to deduct from default price",
  },
];

export const PRICING_OPTIONS_MAP = {
  Actual: "Actual",
  DiscountPercentage: "Discount (%)",
  DiscountAmount: "Discount (Amount)",
};

export const filterOptions = {
  [PRICE_TYPES_OPTION.DEFAULT]: [
    { name: "Product", value: "product" },
    { name: "Status", value: "status" },
    { name: "Registration Category", value: "registrationCategory" },
    { name: "Price ID", value: "priceId" },
  ],
  [PRICE_TYPES_OPTION.DEPOT]: [
    { name: "Product", value: "product" },
    { name: "Depot", value: "depot" },
    { name: "Status", value: "status" },
    { name: "Registration Category", value: "registrationCategory" },
    { name: "Price ID", value: "priceId" },
  ],
  // [PRICE_TYPES_OPTION.CONSUMPTION_BAND]: [
  //   { name: "Product", value: "product" },
  //   { name: "Depot", value: "depot" },
  //   { name: "Status", value: "status" },
  //   { name: "Consumption Band", value: "consumptionBand" },
  //   { name: "Price ID", value: "priceId" },
  // ],
  [PRICE_TYPES_OPTION.CUSTOMER_GROUP]: [
    { name: "Product", value: "product" },
    { name: "Depot", value: "depot" },
    { name: "Status", value: "status" },
    { name: "Customer Group", value: "customerGroup" },
    { name: "Price ID", value: "priceId" },
  ],
};

export const TITLE_MAP = {
  [PRICE_TYPES_OPTION.DEFAULT]: {
    amount: {
      title: "Product Price",
      subTitle: "Set the default(base) price for this product",
    },
  },
  [PRICE_TYPES_OPTION.DEPOT]: {
    amount: {
      title: "Value",
      subTitle: "Set the new price or discount for the selected product",
    },
  },
  [PRICE_TYPES_OPTION.CUSTOMER_GROUP]: {
    amount: {
      title: "Value",
      subTitle: "Set the new price or discount for the selected product",
    },
  },
  // [PRICE_TYPES_OPTION.CONSUMPTION_BAND]: {
  //   amount: {
  //     title: "Value",
  //     subTitle: "Set the new price or discount for the selected product",
  //   },
  // },
};

export const PRICING_OPTION_MARK = {
  Actual: USER_CURRENCY(),
  DiscountPercentage: "%",
  DiscountAmount: USER_CURRENCY(),
};
